import { render, staticRenderFns } from "./ChecklistTab.vue?vue&type=template&id=3c1df678&scoped=true&"
import script from "./ChecklistTab.vue?vue&type=script&lang=js&"
export * from "./ChecklistTab.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistTab.vue?vue&type=style&index=0&id=3c1df678&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1df678",
  null
  
)

export default component.exports